import React from 'react';
import PropTypes from 'prop-types';
import { formatarMoeda, formatarTonelada, toTitleCase } from '../../../../../helpers/formatador';
import { Container } from './styles';
import StatusLoteEnum from '../../../Enum/StatusLoteEnum';
import { formataSemanaData } from '../../../../../helpers/data-fns';

const ItemAgendamento = ({ agendamento }) => {
  const {
    data_alteracao,
    volume,
    cadencia,
    status_lote,
    frete_empresa,
    frete_mototista,
    motivo_suspensao,
  } = agendamento;

  const statusToString = !!status_lote && StatusLoteEnum.getTipo(status_lote).label;

  const getMensagem = () => {
    let mensagem = ' ';
    if (volume) mensagem += ` Volume: ${formatarTonelada(volume, null, 'ton')} /`;

    if (cadencia) mensagem += ` Cadência: ${formatarTonelada(cadencia, null, 'ton')} /`;

    if (statusToString) mensagem += ` Status dos Lotes: ${statusToString} /`;

    if (motivo_suspensao) mensagem += ` Motivo da suspensão: ${motivo_suspensao} /`;

    if (frete_empresa) mensagem += ` Frete Empresa PJ: ${formatarMoeda(frete_empresa)} /`;

    if (frete_mototista) mensagem += ` Frete Empresa PF: ${formatarMoeda(frete_mototista)} /`;

    const last = mensagem.charAt(mensagem.length - 1);

    if (last === '/') mensagem = mensagem.substring(0, mensagem.length - 1);

    return mensagem;
  };

  return (
    <Container>
      <b>{`${toTitleCase(formataSemanaData(data_alteracao))}: `}</b>
      &nbsp;
      <p>{getMensagem()}</p>
    </Container>
  );
};

ItemAgendamento.propTypes = {
  agendamento: PropTypes.shape({
    id: PropTypes.number,
    id_demanda: PropTypes.number,
    data_alteracao: PropTypes.string,
    volume: PropTypes.number,
    cadencia: PropTypes.number,
    status_lote: PropTypes.number,
    frete_empresa: PropTypes.number,
    frete_mototista: PropTypes.number,
    motivo_suspensao: PropTypes.string,
    tipo_alteracao: PropTypes.string,
  }).isRequired,
};

export default ItemAgendamento;
